import React from 'react';
import { Grid, Separator, Text } from 'telia-front-react';
import TradeInConditions from './TradeInConditions';
import TradeInMaxPrice from './TradeInMaxPrice';
import TradeInSelectors from './TradeInSelectors';
const TradeInSelection = ({ headingElement, translate, tradeInStore }) => (React.createElement(Text, null,
    React.createElement(Grid, { align: ['center-xs'] },
        React.createElement(TradeInSelectors, { translate: translate, tradeInStore: tradeInStore })),
    React.createElement(Grid, { align: ['center-xs'] },
        React.createElement(TradeInMaxPrice, { translate: translate, tradeInStore: tradeInStore })),
    React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
    React.createElement(TradeInConditions, { headingElement: headingElement, translate: translate, tradeInStore: tradeInStore })));
export default TradeInSelection;
